<template>
  <vs-popup class="customer-sample-order-create-popup"
            title="PRODUCT ORDER CREATE"
            @close="onClickClose"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card  no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="popup" @submit.prevent="handleSubmit(onClickCreateSampleOrder)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-2/3 w-full md:mb-0">
                  <vs-table :data="cartItems" stripe>
                    <template slot="header">
                      <h3>
                        <span class="text-danger text-lg mb-8">Available credit (GBP):  <b>{{creditDetails.available_credit}}</b></span>
                      </h3>
                    </template>
                    <template slot="thead">
                      <vs-th width="15%">CODE</vs-th>
                      <vs-th width="20%">NAME</vs-th>
                      <vs-th width="15%">QUANTITY (KG/{{__accountCurrency()}})</vs-th>
                      <!--                      <vs-th width="15%">PRICE TYPE</vs-th>-->
                      <vs-th width="15%">UNIT PRICE (KG)</vs-th>
                      <vs-th width="15%">TOTAL PRICE ({{__accountCurrency()}})</vs-th>
                      <vs-th width="20%">ACTIONS</vs-th>
                    </template>

                    <template slot-scope="{data}">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].formulation_code">
                          {{ data[indextr].formulation_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].formulation_name">
                          {{ data[indextr].formulation_name }}
                        </vs-td>
                        <vs-td :data="data[indextr].quantity">
                          <ValidationProvider :vid="indextr + 'quantity' " :name="indextr + 'quantity'" :rules="'moq:'+data[indextr].min_order_quantity" v-slot="{ errors }">
                            <vs-input
                              :disabled="data[indextr].type === 'contract'"
                              v-on:input="onChangeQty(data[indextr], indextr)"
                              type="text"
                              v-model="data[indextr].quantity" class="w-full"
                              :name="'quantity'" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                          </ValidationProvider>
                        </vs-td>

                        <vs-td :data="data[indextr].unit_price">
                          {{ data[indextr].unit_price }}
                        </vs-td>

                        <vs-td :data="data[indextr].unit_price">
                          {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                        </vs-td>


                        <vs-td :data="data[indextr].formulation_id">
                          <div class="vx-row">
<!--                          <vx-tooltip class="mr-2" text="Update" position="left">-->
<!--                            <vs-button :disabled="!(data[indextr].quantity && data[indextr].quantity >= data[indextr].min_order_quantity)"-->
<!--                                        @click="onClickUpdateFromCart(data[indextr])"-->
<!--                                       size="small" color="warning" type="border" icon-pack="feather" icon="icon-delete">Update</vs-button>-->
<!--                          </vx-tooltip>-->
                          <vx-tooltip class="mr-2" text="Remove cart" position="left">
                            <vs-button @click="onClickRemoveFromCart(data[indextr].id)"
                                       size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                          </vx-tooltip>
                          </div>
                        </vs-td>

                      </vs-tr>
                      <vs-tr>
                        <vs-td style="font-weight: bolder">Total ({{__accountCurrency()}})</vs-td>
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                        <vs-td></vs-td>
                        <vs-td style="font-weight: bolder">{{totalCalculator()}}</vs-td>
                        <vs-td></vs-td>
                      </vs-tr>
                    </template>

                  </vs-table>
            </div>

              <div class="vx-col md:w-1/3 w-full md:mb-0">
                <vx-card>
                <div class="vx-row mb-3" v-if="onClickAddressChange">
                  <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="formulation_items" name="formulation_items" rules="required" v-slot="{ errors }">
                      <small class="label">Select a delivery address</small>
                      <v-select
                        v-on:input="onChangeSelectDeliveryAddress"
                        @search="onSearch"
                        name="formulation_items" placeholder=""
                        v-model="selectedAddress" :reduce="option => option"
                        label="country"
                        :options="addresses" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                        <template slot="option" slot-scope="option">
                          <div class="d-center">
                            <span style="font-weight: normal">{{ option.name }}</span> <br>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <br>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <br>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <br>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <br>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <br>
                            <span style="font-weight: normal">{{ option.country }}</span> <br>
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            <span style="font-weight: normal">{{ option.name }}</span> <br>
                            <span style="font-weight: normal">{{ option.line1 }}</span> <br>
                            <span style="font-weight: normal">{{ option.line2 }}</span> <br>
                            <span style="font-weight: normal">{{ option.line3 }}</span> <br>
                            <span style="font-weight: normal">{{ option.town_state }}</span> <br>
                            <span style="font-weight: normal">{{ option.post_code }}</span> <br>
                            <span style="font-weight: normal">{{ option.country }}</span> <br>
                          </div>
                        </template>
                      </v-select>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3" v-if="onClickAddressChange">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <span style="cursor: pointer" class="float-right text-primary" @click="onClickAddressChange = false">or add delivery address</span>
                    </div>
                  </div>

                <span v-if="!onClickAddressChange">
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-full w-full md:mb-0">
                      <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                        <small class="label">Site Name</small>
                        <vs-input v-model="form.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 1</small>
                      <vs-input v-model="form.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line2" name="line2" rules="required" v-slot="{ errors }">
                      <small class="label">Address Line 2</small>
                      <vs-input v-model="form.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                      <small class="label">Address Line 3</small>
                      <vs-input v-model="form.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                      <small class="label">Town / State</small>
                      <vs-input v-model="form.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                </div>

                  <div class="vx-row mb-3">
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                      <small class="label">Postal Code</small>
                      <vs-input v-model="form.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                      <small class="label">Country</small>
                      <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                                label="name" v-model="form.country" :reduce="option => option.name"
                                :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                  <div class="vx-row mb-3">
                      <div class="vx-col md:w-full w-full md:mb-0">
                        <span style="cursor: pointer" class="float-right text-primary" @click="onClickAddressChange = true">change delivery address</span>
                      </div>
                  </div>
                </span>


                <div class="vx-row mb-3 mt-8">
                  <div class="vx-col w-full">
                    <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                      <small class="label">Delivery Instructions</small>
                      <vs-textarea class="mb-0" v-model="form.delivery_instruction" height="150px" />
                      <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                </vx-card>
              </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Order</vs-button>
            <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
    <create-customer-account-limit-request-pop-up v-bind:account_currency="'GBP'" ref="createCustomerAccountLimitRequestPopUp" />
    <customer-credit-check-pop-up
      v-on:openCreditLimitRequest="openCreditLimitRequest"
      v-on:refreshData="onlyRefreshData"
      v-on:onlyRefreshData="onlyRefreshData"
      ref="customerCreditCheckPopUp"/>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const FormulationsRepository = RepositoryFactory.get('formulations');
  import CustomerCreditCheckPopUp from '@/components/popups/customer/product-orders/CustomerCreditCheckPopUp'
  import CreateCustomerAccountLimitRequestPopUp from '@/components/popups/customer/account-limit-request/CreateCustomerAccountLimitRequestPopUp'

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import Calculations from '@/mixins/Calculations'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        town_state: '',
        post_code: '',
        country: '',
        delivery_instruction: '',
        formulation_items: []
      },
      countryCodes: [],
      customerUsers: [],
      isCreateFromMainMenu: false,
      customers: [],
      formulations: [],
      addresses: [],
      selectedAddress: '',
      cartItems: [],
      onClickAddressChange: true,
      productCatalogues: []
    }
  }

export default {
  name: 'TrackingImagePopUp',
  data () {
    return initialState()
  },
  props: {
    creditDetails  : {type: Object,  default: {}}
  },
  methods:{
    async openPopup (id) {
      try {
        Object.assign(this.$data, initialState())
        this.id = id
        await this.getCountryCodes()
        await this.getAddresses()
        await this.getItemsInItemsCart()
        // this.getFormulations()
        this.open = true;
      } catch (error) {

      }
    },
    async onlyRefreshData() {
      await this.getItemsInItemsCart()
    },
    async openCreditLimitRequest() {
      await this.onlyRefreshData()
      await this.$refs.createCustomerAccountLimitRequestPopUp.openPopup(this.id)
    },
    async onClickClose() {
      const vue = this;
      this.open = false
      await vue.$parent.onlyRefreshData()
    },
    async onClickCreateSampleOrder () {
      const vue = this;
      this.$vs.loading()
       try {
         this.form.customer_id = this.id
         this.form.formulation_items = this.cartItems.map((m) => {
           return { id: m.formulation_id, quantity: m.quantity, price: (Number(m.unit_price)).toFixed(2), type: m.type}
         })

         await CustomerRepository.createCustomerProductOrder(this.form)
         this.showSuccessMessage('Product order created successfully')
         this.open = false;
         await vue.$parent.refreshData()

       }catch (e) {
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async getFormulations() {
      this.$vs.loading()
      const {data} = await FormulationsRepository.get(1, '', 50, '')
      this.formulations =  data.data
      this.$vs.loading.close()
    },
    async getCountryCodes() {
      this.$vs.loading()
      this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
      this.$vs.loading.close()
    },
    async getAddresses() {
      this.$vs.loading()
      this.addresses = (await CustomerRepository.getCustomerProductDeliveryAddresses(this.id)).data.data;
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    doCheckItems(data) {
      console.log(data)
    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    async getItemsInItemsCart() {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        this.productCatalogues = (await CustomerRepository.getListOfProductCatalogue('')).data.data
        const {data} = (await CustomerRepository.getItemsInProductCart(this.id)).data
        this.cartItems = data

        this.cartItems = this.cartItems.map((n) => {
          const find =  this.productCatalogues.find((m) => m.id === n.formulation_id)
          n.min_order_quantity = find.min_order_quantity
          n.incoterm = find.incoterm
          n.unit_price = n.price
          n.price = find.price
          n.pe_g = find.pe_g
          return n
        })
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async onClickRemoveFromCart(id) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        await CustomerRepository.removeFormulationsFromProductCart(id)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Remove from cart!')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    async onClickUpdateFromCart(data) {
      await this.$vs.loading({
        container: '#popup',
        scale: 0.45
      })
      try {
        const payload = {quantity: data.quantity, price: data.unit_price}
        await CustomerRepository.updateFormulationsQuantityInProductCart(data.id, payload)
        await this.getItemsInItemsCart()
        this.showSuccessMessage('Product item quantity updated')
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#popup > .con-vs-loading')
    },
    onChangeSelectDeliveryAddress(selected) {
      this.form.name = selected.name
      this.form.line1 = selected.line1
      this.form.line2 = selected.line2
      this.form.line3 = selected.line3
      this.form.town_state = selected.town_state
      this.form.post_code = selected.post_code
      this.form.country = selected.country
      this.form.delivery_instruction = selected.additional_info
      this.onClickAddressChange = false
    },
    totalCalculator() {
      let total = 0;
      this.cartItems.forEach((m) => {
        if (!!m.unit_price) {
          total = total + Number(m.unit_price) * Number(m.quantity)
        }

      })
      return total.toFixed(2)
    },
    onChangeQty(data, index) {
      this.cartItems[index].unit_price =  this.calculateProductListPrice(data.pe_g, data.quantity, data.fx_rate)
      if (Number(data.quantity) >= Number(data.min_order_quantity)) {
        this.updateCart(data, this)
      }
    },
    updateCart: _.debounce( async (data, vm) => {

      if (!vm.isCanAddOrderWithCredit()) {
        await vm.openCreditCheckPopUp()
        return null
      }

      await vm.onClickUpdateFromCart(data)
    }, 500),
    isCanAddOrderWithCredit() {
      if(this.creditDetails.account_type === 'proforma') {
          return true
      }
      const cart_total = this.totalCalculator()
      const available_credit = this.creditDetails.available_credit
      return Number(cart_total) < Number(available_credit)
    },
    async openCreditCheckPopUp() {
      await this.$refs.customerCreditCheckPopUp.openPopup(this.customerId)
    }

  },
  async mounted () {

  },
  computed: {

  },
  components: {
    'v-select': vSelect,
    CustomerCreditCheckPopUp,
    CreateCustomerAccountLimitRequestPopUp
  },
  mixins: [SuccessMessage, ErrorMessages, Calculations],
}
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    min-height: 80% !important;
    min-width: 90% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
